//import React from "react"
import firebase from 'firebase';

export class GetListService {
  // NORMALIZE STRING TO LOWERCASE AND WITHOUT ACCENTS
  _normalizeString = string =>
    string
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  getList = (resource, params) => {
    console.warn('getList:', resource, params);
    const { field, order } = params.sort;
    const {
      missionsId: filterByMission,
      userId: filterByUser,
      searchQuery,
      companyId
    } = params.filter;

    return firebase
      .database()
      .ref(resource === 'contributions' ? 'missions' : resource)
      .once('value')
      .then(snapshot => {
        let response = Object.entries(snapshot.val()).map(entry =>
          Object.assign({}, { id: entry[0] }, entry[1])
        );

        // CREATE "IsPlanned" PROPERTY
        if (resource === 'events') {
          let pushableEvents = [];
          response.forEach(event => {
            event.isPlanned = !event.isCanceled;
            pushableEvents.push(event);
          });

          // IF SOMETHING IS TYPED IN EVENT SEARCH INPUT
          if (searchQuery) {
            const filteredEvents = pushableEvents.filter(event => {
              const { title, host, location } = event;
              const filters = [title, host, location];
              let result = false;
              for (var filter of filters) {
                result |= this._normalizeString(filter).includes(
                  this._normalizeString(searchQuery)
                );
              }
              return result;
            });
            response = filteredEvents;
          } else {
            response = pushableEvents;
          }
        }

        // TO FILTER/SEARCH USERS OR COMPANIES
        else if (resource === 'users' || resource === 'companies') {
          // search in User name in UserList or Company Name in CompanyList
          searchQuery &&
            (response = response.filter(value =>
              this._normalizeString(value.name).includes(
                this._normalizeString(searchQuery)
              )
            ));

          // Filter user by companies
          companyId &&
            (response = response.filter(user => user.companyId === companyId));

          // Get all Users and push each user to its company
          if (resource === 'companies') {
            const getUsers = () =>
              firebase
                .database()
                .ref('users')
                .once('value')
                .then(snapshot => snapshot.val());
            response.sort((a, b) => {
              let left = a[field],
                right = b[field];

              if (typeof left === 'string' && typeof right === 'string') {
                left = this._normalizeString(left);
                right = this._normalizeString(right);
              }

              if (left < right) return order === 'DESC' ? 1 : -1;
              else if (left > right) return order === 'ASC' ? 1 : -1;
              return 0;
            });
            return Promise.all([getUsers()]).then(([users]) => {
              let companies = response;
              companies.filter(company => {
                Object.assign(company, { users: [] });

                const objectToArrayWithId = values =>
                  Object.entries(values).map(value =>
                    Object.assign({}, { id: value[0] }, value[1])
                  );

                return objectToArrayWithId(users).filter(
                  user =>
                    user.companyId === company.id && company.users.push(user)
                );
              });
              return {
                data: companies,
                total: companies.length
              };
            });
          }
        } else if (resource === 'missions' || resource === 'contributions') {
          // const missionByIds = snapshot.val();
          // const getMissionTitle = id => {
          //   return missionByIds[id].title;
          // };

          const getMissionsWithFilter = (missions, filter) => {
            const missionsFiltered = missions.filter(mission =>
              mission.title.toLowerCase().includes(filter.toLowerCase())
            );
            return missionsFiltered;
          };

          // IF SOMETHING IS TYPED IN MISSIONS OR CONTRIBUTIONS SEARCH INPUT
          let missions = response;
          if (searchQuery) {
            missions = getMissionsWithFilter(missions, searchQuery);
          }

          if (resource === 'contributions') {
            let contributions = [];

            contributions = missions.reduce((reduced, mission) => {
              if (mission.contributions) {
                const contributions = Object.entries(mission.contributions).map(
                  entry =>
                    Object.assign(
                      {},
                      { id: entry[0], missionId: mission.id },
                      entry[1]
                    )
                );

                reduced = reduced.concat(contributions);
              }
              return reduced;
            }, []);

            if (filterByMission || filterByUser) {
              contributions = contributions.filter(c => {
                let result = true;
                if (filterByMission) result &= c.missionId === filterByMission;
                if (filterByUser) result &= c.userId === filterByUser;
                return result;
              });
            }

            // // TO SORT A LIST
            // if (order) {
            //   contributions.sort((a, b) => {
            //     console.log(
            //       'contributions in if a, b, order, field',
            //       a,
            //       b,
            //       order,
            //       field
            //     );
            //     console.log('a[field]', getMissionTitle(a[field]));
            //     if (getMissionTitle(a[field]) < getMissionTitle(b[field]))
            //       return order === 'DESC' ? 1 : -1;
            //     else if (getMissionTitle(a[field]) > getMissionTitle(b[field]))
            //       return order === 'ASC' ? 1 : -1;
            //     return 0;
            //   }, field);
            // }

            response = contributions;
          } else {
            response = missions;
          }
        }
        if (order) {
          const dateFields = ['start', 'end', 'startDate', 'endDate'];
          const arrayLength = ['eventIds', 'missionIds', 'users'];
          const reference = ['companyId', 'userId', 'missionId'];

          let tmp = 0;
          let Field = field;
          if (field === "metadata.lastSignInTime") {
            tmp = 1
            Field = "metadata"
          } else if (field === "metadata.creationTime") {
            tmp = 2
            Field = "metadata"
          }
          response.sort((a, b) => {
            let left = a[Field],
              right = b[Field];

            if (dateFields.includes(Field)) {
              left = new Date(left);
              right = new Date(right);
            } else if (reference.includes(Field)) {
              let missionByIds = Object.entries(snapshot.val()).map(entry =>
                Object.assign({}, { id: entry[0] }, entry[1])
              );
              missionByIds.forEach(function(objectId) {
                if (left === objectId.id) left = objectId.title;
                if (right === objectId.id) right = objectId.title;
              });
            } else if (arrayLength.includes(Field)) {
              left = left ? left.length : 0;
              right = right ? right.length : 0;
            } else if (tmp === 1) {
              left = left ? left.lastSignInTime : null;
              right = right ? right.lastSignInTime : null;
            } else if (tmp === 2) {
              left = left ? left.creationTime : null;
              right = right ? right.creationTime : null;
            }


            if (typeof left === 'string' && typeof right === 'string') {
              left = this._normalizeString(left);
              right = this._normalizeString(right);
            }
            if ((tmp === 1 || tmp === 2) && (left === null || right === null)) return left === null ? 1 : -1;
            if (tmp === 0 && left == null) return order === 'ASC' ? 1 : -1;
            if (tmp === 0 && right == null) return order === 'DESC' ? 1 : -1;
            if (left < right) return order === 'DESC' ? 1 : -1;
            else if (left > right) return order === 'ASC' ? 1 : -1;
            return 0;
          });
        }
        let max = params.pagination.page * params.pagination.perPage;
        let i = 0;
        let pushableEvents = [];
        response.forEach(event => {
          if (i < max && i >= max - params.pagination.perPage) {
            event.isPlanned = !event.isCanceled;
            pushableEvents.push(event);
          }
          i += 1;
        });
        return { data: pushableEvents, total: response.length };
      });
  };
}



// WEBPACK FOOTER //
// ./src/services/GetListService.js